import React, { useEffect, useState } from 'react';
import { generatePath } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Button, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import AndroidIcon from '@material-ui/icons/Android';
import AppleIcon from '@material-ui/icons/Apple';
import { osName, OsTypes } from 'react-device-detect';

import ringback from './../ringback';
import { currentLocation } from './../location';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '90vh',
    maxWidth: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  buildingHeading: {
    fontWeight: '200',
    marginTop: '10px',
    marginBottom: '10px',
  },
  installButton: {
    position: 'absolute',
    left: '0px',
    bottom: '0px',
    width: '100%',
  },
}));

const Residents = ({ baseURL, buildingId, history }) => {
  const classes = useStyles();

  const [residents, setResidents] = useState([]);
  const [building, setBuilding] = useState({ name: '' });

  useEffect(() => {
    if (baseURL) {
      currentLocation()
        .then((location) => {
          console.log('location', location);
          return fetch(`${baseURL}/buildings/${buildingId}/residents?` + new URLSearchParams(location));
        })
        .then((res) => {
          if (res.status === 401) {
            history.push(
              generatePath('/buildings/:buildingId/doorbell/out-of-range', {
                buildingId,
              }),
            );
            return Promise.reject(new Error('Out of range building'));
          }
          if (res.status !== 200) {
            return Promise.reject(new Error('Wrong request: ' + res.body));
          }
          return res.json();
        })
        .then((all) => {
          setResidents(all.residents.map((r) => ({ name: r.name, id: r.id })));
          setBuilding(all.building);
        })
        .catch((err) => console.error(err));
    }
  }, [baseURL, buildingId, history]);

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="residents">
        <Typography className={classes.buildingHeading} align="center" variant="h5">
          {building.name}
        </Typography>
        {residents.map((resident) => (
          <ListItem
            key={resident.id}
            button={true}
            onClick={(_event) => {
              // NOTE: we start to play the ringback tune here and not in the
              // Call page because in a web application you can only play a
              // sound in a callback triggered by an user action like this one
              ringback.then((tune) => tune.play());
              history.push(
                generatePath('/buildings/:buildingId/doorbell/residents/:residentId/call', {
                  buildingId,
                  residentId: resident.id,
                  residentName: resident.name,
                }),
              );
            }}
          >
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary={resident.name} secondary={resident.id} />
          </ListItem>
        ))}
      </List>
      {osName === OsTypes.Android && (
        <Button
          startIcon={<AndroidIcon />}
          className={classes.installButton}
          size="large"
          color="primary"
          variant="contained"
          href="https://play.google.com"
        >
          Install Native Application
        </Button>
      )}
      {osName === OsTypes.IOS && (
        <Button
          startIcon={<AppleIcon />}
          className={classes.installButton}
          size="large"
          color="primary"
          variant="contained"
          href="https://apps.apple.com/it/app/amazon-prime-video/id545519333"
        >
          Install Native Application
        </Button>
      )}
    </div>
  );
};

export default Residents;
